<template>
    <div class="p-3 h-100 is-flex is-flex-column is-flex-hcenter">
        <b-carousel
            :pause-info="false"
            :animated="'fade'"
            :repeat="false"
            icon-size='is-medium'
            height="100%"
        >
            <b-carousel-item v-for="(foto, index) in fotosToDisplay" :key="index">
                <section class="hero is-medium">
                    <div class="hero-body-img has-text-centered custom-size">
                        <img
                            class="img-size"
                            :src="foto.caminho"
                            :alt="foto.nome"
                            loading="lazy"
                        />
                    </div>
                </section>
            </b-carousel-item>
        </b-carousel>
    </div>
</template>

<script>
export default {
    props: {
        fotosToDisplay: {
            type: Array,
            default: []   
        },
    },
}
</script>

<style lang="scss" scoped>
.is-flex ::v-deep .carousel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
}

.h-100 {
    height: 100%;
}

.img-size {
    max-height: 80vh;
}

.custom-size {
    max-height: 80vh;
}
</style>